var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBagOncolorOncolor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 9.00005H17C17 6.5 14.7614 4 12 4C9.23856 4 7 6.5 7 9.00005H3C2.45 9.00005 2 9.45005 2 10C2 10.09 2.01 10.18 2.04 10.27L4.58 19.54C4.81 20.38 5.58 21 6.5 21H17.5C18.42 21 19.19 20.38 19.43 19.54L21.97 10.27L22 10C22 9.45005 21.55 9.00005 21 9.00005ZM9 9.00005H15C15 7.34318 13.6569 6 12 6C10.3431 6 8.99997 7.34318 9 9.00005ZM6.51 19.01L17.5 19L19.7 11H4.31L6.51 19.01Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagOncolorOncolor);
export default __webpack_public_path__ + "static/media/bag_oncolor_oncolor.faf2608516b4865ed8a55e21d1beed68.svg";
export { ForwardRef as ReactComponent };